import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Catalogo } from '../../../../../interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { CatalogoService } from '../../../../../services/shared/catalogo.service';
import { EntidadesKeys } from 'src/app/enum/entidades-keys.enum';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import Swal from 'sweetalert2';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { AuthService } from '@services/auth/auth.service';

@Component({
    selector: 'app-rubros-listado',
    templateUrl: './rubros-listado.component.html',
    styleUrls: ['./rubros-listado.component.scss'],
})
export class RubrosListadoComponent implements OnInit, AfterViewInit {
    @ViewChild('previousRoute') previousRouteLink : ElementRef;

    /* Data Table*/
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = ['rubro', 'activo', '_id'];
    dataSource: MatTableDataSource<Catalogo>;
    rubros: Catalogo[] = [];
    /* Fin Data Table*/

    flagLoaded: boolean = false;
    keyPerfil: string = '';

    constructor(
        private catalogoService: CatalogoService,
        private router: Router,
        private guiMsjService: GuiMsjService,
        private perfilesService: PerfilesService,
        private authService: AuthService,
    ) {
        this.dataSource = new MatTableDataSource();
    }

    ngOnInit(): void {
        this.getPerfil().then(() => {
            this.perfilesService.allowedByUserLogon(this.router.url,  this.previousRoute, this.keyPerfil);
        });
        this.loadDataPage();
    }

    async ngAfterViewInit() {
        await this.loadDataPage();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    get previousRoute() {
        const previousRoute = this.previousRouteLink.nativeElement.getAttribute('href');
        return previousRoute;
    }

    async getPerfil() {
        try {
            const user = await this.authService.getUserLogon();
            if (user) {
                const { key } = user?.perfil
                this.keyPerfil = key;
            }
        }
        catch (error) {
            console.log('ABM - Error al obtener el perfil del usuario', error);
            return '';
        }
    }

    async verRubro(id: string) {
        await this.guiMsjService.msjFormSubmit('Espere');
        Swal.showLoading();
        const rubro: Catalogo = await this.catalogoService.getFindOne(id);
        if (rubro !== undefined) {
            this.router.navigateByUrl('/rubro-modificacion');
            this.catalogoService.setConcepto(rubro);
        } else {
            Swal.close;
        }
    }

    async loadDataTable() {
        const rubros = await this.catalogoService.findDescendantsByKey(EntidadesKeys.RUBROS);
        this.dataSource.data = rubros;
    }

    applyFilter(event: Event) {
        const filterValue = (event?.target as HTMLInputElement)?.value.trim().toLowerCase();
        const customFilter = (data: any, filter: string): boolean => {
            // Verifica si el valor del filtro está en las columnas
            return (
                data.concepto.toLowerCase().includes(filter) ||
                (data.logico_1 ? 'Si' : 'No').toLowerCase().includes(filter)
            );
        };

        // Aplica el filtro personalizado
        this.dataSource.filter = filterValue;
        this.dataSource.filterPredicate = customFilter;
    }

    async loadDataPage() {
        await this.loadDataTable();
        this.flagLoaded = true;
    }
}
